import React from "react";
import { useIntl } from "react-intl";

import InformationPage from "components/GenericPage/InformationPage";
import { titles, labels } from "resources/resources";
import { DISPLAY_DATA_CONTENT_TYPE } from "utils/const";

function MissionVisionAndValues() {
  const intl = useIntl();

  const missionVisionAndValuesData = [
    {
      title: intl.formatMessage(
        labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_Mission
      ),
      content: [
        intl.formatMessage(
          labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_MissionDescription
        ),
      ],
    },
    {
      title: intl.formatMessage(
        labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_Vision
      ),
      content: [
        intl.formatMessage(
          labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_VisionDescription
        ),
      ],
    },
    {
      title: intl.formatMessage(
        labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_Values
      ),
      content: [
        {
          type: DISPLAY_DATA_CONTENT_TYPE.FIRST_BULLET_POINT,
          description: intl.formatMessage(
            labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_ValuesDescription_1
          ),
        },
        {
          type: DISPLAY_DATA_CONTENT_TYPE.BULLET_POINT,
          description: intl.formatMessage(
            labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_ValuesDescription_2
          ),
        },
        {
          type: DISPLAY_DATA_CONTENT_TYPE.BULLET_POINT,
          description: intl.formatMessage(
            labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_ValuesDescription_3
          ),
        },
        {
          type: DISPLAY_DATA_CONTENT_TYPE.BULLET_POINT,
          description: intl.formatMessage(
            labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_ValuesDescription_4
          ),
        },
        {
          type: DISPLAY_DATA_CONTENT_TYPE.BULLET_POINT,
          description: intl.formatMessage(
            labels.Label_Menu_InstitutionalInformation_MissionVisionAndValues_ValuesDescription_5
          ),
        },
      ],
    },
  ];

  return (
    <InformationPage
      title={intl.formatMessage(
        titles.Title_Menu_InstitutionalInformation_MissionVisionAndValues
      )}
      data={missionVisionAndValuesData}
    />
  );
}

export default MissionVisionAndValues;
